/*
 * @Author: Kuiper
 * @Date: 2021-06-24 18:24:06
 */
import { createApp } from 'vue'
import App from './App.vue'
import { router, setupRouter } from '/@/router'
import { setupRouterGuard } from '/@/router/guard'
import { setupStore } from '/@/store'
import { setupAntd, setupGlobalMethods, setupCustomComponents, setupPwa } from '/@/plugins'
import { setupErrorHandle } from './utils/error-handler/index'

async function bootstrap() {
  const app = createApp(App)

  // Configure store
  setupStore(app)

  // 注册全局常用的ant-design-vue组件
  setupAntd(app)

  // 注册全局自定义组件,如：<svg-icon />
  setupCustomComponents(app)

  // 注册全局方法，如：app.config.globalProperties.$message = message
  setupGlobalMethods(app)

  // Configure routing
  setupRouter(app)

  // router-guard
  setupRouterGuard(router)

  // Mount when the route is ready
  // https://next.router.vuejs.org/api/#isready
  await router.isReady()

  // sentry
  setupErrorHandle(app, router)

  // progress web application
  setupPwa()

  app.mount('#app', true)
}
void bootstrap()
